import { render } from "./CxLabel.vue?vue&type=template&id=1eb31054&scoped=true"
import script from "./CxLabel.vue?vue&type=script&lang=js"
export * from "./CxLabel.vue?vue&type=script&lang=js"

import "./CxLabel.vue?vue&type=style&index=0&id=1eb31054&lang=less&scoped=true"

import exportComponent from "/home/ec2-user/workspace/_conx-ui-monorepo_ui2_lab_master/apps/ui2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1eb31054"]])

export default __exports__